import { UseBaseMutationOptions } from '@/core/api/type'
import { useMutation } from '@tanstack/react-query'
import { OperatorQueryKey } from '@/modules/operator/keys'
import {
	GetUploadlFileUrlRequest,
	GetUploadFileUrlResponse,
} from '@/modules/operator/type'
import { getRankFrameUploadFileUrl } from '../../services'

interface CreateFileUrlParams {
	payload: GetUploadlFileUrlRequest
}

export default function useMutationCreateRankFrameFileUrl(
	props?: UseBaseMutationOptions<GetUploadFileUrlResponse, CreateFileUrlParams>,
) {
	return useMutation({
		mutationKey: [OperatorQueryKey.GetUploadRankFrameFileUrl],
		mutationFn: (params) => getRankFrameUploadFileUrl(params.payload),
		...props,
	})
}
